<template>
    <div>
        <Table border :columns="columns5" :data="periodList">
            <template slot="credit" slot-scope="{row}">
                <div v-if="type === 1 || type === 2 || type === 4" class="importStatus">{{row.peopleOfficeStatus | statusImport}}</div>
                <div v-else class="importStatus">{{row.abutmentStatus | statusImport}}</div>
            </template>
            <template slot="action" slot-scope="{row}">
                <span class="details" @click="clkDetails(row)">导入详情</span>
            </template>
        </Table>

        <div class="gray">备注：1、学时(学分)查询网址-浙江省专业技术人员继续教育学时登记管理系统：<span class="details">https://zjjx.rlsbt.zj.gov.cn/</span></div>

        <div class="gray">2、导入结果为专业科目学时（学分），仅显示XX年XX月XX日与浙江省专业技术人员继续教育学时登记管理系统对接后结果！</div>

        <div class="gray">3、如果导入失败，请查看反馈原因，如有疑问请与服务中心联系：：0571-88903229</div>

        <el-dialog title="导入结果" :visible.sync="failShow" width="30%">
            <el-form label-position="left" label-width="80px">
                <el-form-item label="年度">
                    {{rowData.trainTime}}
                </el-form-item>
                <el-form-item label="专业">
                    {{rowData.majorName}}
                </el-form-item>
                <el-form-item label="导入学时">
                    {{rowData.finishedPeriod}}
                </el-form-item>
                <el-form-item label="导入时间">
                    {{rowData.peopleOfficeTime}}
                </el-form-item>
                <el-form-item label="导入系统">
                    {{rowData.operTypeame | typeImport(type)}}
                </el-form-item>
                <el-form-item label="导入状态">
                    {{rowData.peopleOfficeStatus | statusImport}}
                </el-form-item>
                <el-form-item label="失败原因">
                    <span v-if="type === 1 || type === 2 || type === 4">{{rowData.peopleOfficeFailReson}}</span>
                    <span v-else>{{rowData.abutmentFailReson}}</span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="failShow = false">取 消</el-button>
                <el-button type="primary" @click="failShow = false">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        props: {
            periodList: Array,
            type: Number
        },
        data(){
            return{
                columns5: [
                    {
                        title: '项目',
                        key: 'projectName',
                        minWidth: 80, 
                        align: "center",
                        
                    },
                    {
                        title: '科目分类',
                        align: "center",
                        minWidth: 100, 
                        render(h, params) {
                            if (params.row.subjectType == 1) {
                                return h(
                                    "span", {
                                        style: {
                                            color: "#888",
                                        },
                                    },
                                    "一类专业学时"
                                );
                            }else if (params.row.subjectType == 2) {
                                return h(
                                    "span", {
                                        style: {
                                            color: "#3562E8",
                                        },
                                    },
                                    "二类专业学时"
                                );
                            }
                        },
                    },
                    {
                        title: '学时',
                        align: "center",
                        key: 'finishedPeriod',
                    },
                    {
                        title: '学分',
                        align: "center",
                        key: 'credit'
                    },
                    {
                        title: '学时(学分)导入结果',
                        align: "center",
                        key: 'credit',
                        minWidth: 100, 
                        slot: 'credit'
                    },
                    {
                        title: '操作',
                        align: "center",
                        key: 'credit',
                        minWidth: 100, 
                        slot: 'action'
                    },
                ],
                failShow: false,
                rowData: {},
            }
        },
        created(){
        },
        filters: {
            typeImport(val,type) {
                if(type === 1) {
                    return '浙江省专业技术人员继续教育学时登记管理系统';
                }
                else {
                    return '浙江药师网';
                }
            },
            statusImport(val) {
                if(!val) {
                    return '暂未同步'
                }
                if(val === 1) {
                    return '导入失败'
                }
                if(val === 2) {
                    return '导入成功'
                }
            },
        },
        methods: {
            clkDetails(data) {
                this.rowData = data;
                this.failShow = true;
            }
        },
    };
</script>
<style lang="less" scoped>
.importStatus {
    margin-right: 10px;
    display: inline-block;
}

.details {
    color: #3562e8;
}
.gray {
    color: #999;
}
</style>